//
// Simple Reel Class
//
// Used to create, spin and animate reels
// Contains no logic. Is given a reel strip and it spins from one end to the other.
// Set up reels as follows:
//
//    1 - reelManager.addSymbolAnimationTextures(index, textureArray)
//    2 - Call reelManager.createReel
//    3 - reel.setSymbol to change initial symbols
//
// To use
//
//    1 - Set data using reel.setData(arrayOfSymbolIndexes)
//    2 - startSpin()
//
//

reelBoxStripManager = {};
reelBoxStripManager.reelBoxStrips = [];

reelBoxStripManager.getFilesRequired = function (json) {
  return textureParser
    .getFilesRequired(json.standardImages)
    .concat(textureParser.getFilesRequired(json.gemImages));
};

reelBoxStripManager.createReelBoxStrip = function (json) {
  var reelBoxStrip = new PIXI.Container();
  if (
    checkForUndefined(
      json.reel,
      "Reel box strip needs to be linked to a reel using 'reel' parameter in layout.json"
    )
  ) {
    return;
  }

  return reelBoxStrip;
};
reelBoxStripManager.initialiseReelBoxStrip = function (json, reelBoxStrip) {
  var i;
  var preapperatureSymbols = resourceManager.get(json.reel).configParams
    .preappertureSymbols;
  var appertureHeight = resourceManager.get(json.reel).configParams
    .appertureHeight;
  var totalImages = Number(json.totalImages);

  var position = {
    x: 0,
    y:
      reelManager.symbolHeight *
      preapperatureSymbols *
      resourceManager.selectedAssetResolution.scaleFactor,
  };
  reelBoxStrip.position.set(position.x, position.y);

  reelBoxStrip.showBox = function (spriteIndex, winlineIndex, boxText) {
    if (boxText) {
      // We are showing a gem box
      reelBoxStrip.stripGemSprites[spriteIndex].visible = true;
      reelBoxStrip.stripSprites[spriteIndex].visible = false;
      reelBoxStrip.stripGemSprites[spriteIndex].gotoAndStop(
        winlineIndex + reelBoxStrip.stripSprites[spriteIndex].totalFrames
      );

      // Show text
      if (reelBoxStrip.stripTexts.length === 0) {
        console.error(
          "Box text was requested in reelBoxStrip but no fontDefinition was defined in index for " +
            reelBoxStrip.Props.FQN
        );
      } else {
        reelBoxStrip.stripTexts[spriteIndex].setText(boxText);
        reelBoxStrip.stripTexts[spriteIndex].visible = true;
      }
    } else {
      // We are showing a standard box
      reelBoxStrip.stripSprites[spriteIndex].visible = true;
      reelBoxStrip.stripGemSprites[spriteIndex].visible = false;
      reelBoxStrip.stripSprites[spriteIndex].gotoAndStop(winlineIndex);
    }
  };

  reelBoxStrip.hideAllBoxes = function () {
    for (var i = 0; i < appertureHeight; i++) {
      reelBoxStrip.stripSprites[i].visible = false;
      reelBoxStrip.stripGemSprites[i].visible = false;
      if (reelBoxStrip.stripTexts[i]) {
        reelBoxStrip.stripTexts[i].text = "";
        reelBoxStrip.stripTexts[i].visible = false;
      }
    }
  };

  reelBoxStrip.stripSprites = [];
  reelBoxStrip.stripGemSprites = [];

  reelBoxStrip.stripTexts = [];
  for (var i = 0; i < appertureHeight; i++) {
    var position = {
      x: 0,
      y:
        reelManager.symbolHeight *
        i *
        resourceManager.selectedAssetResolution.scaleFactor,
    };

    // Create winline box movie here
    var stripSprite = resourceManager.createObject(
      "movie",
      "box" + i,
      json.FQN,
      { definition: json.standardImages, x: position.x, y: position.y }
    );
    stripSprite.visible = false;
    stripSprite.gotoAndStop(i);
    reelBoxStrip.stripSprites.push(stripSprite);

    var stripGemSprite = resourceManager.createObject(
      "movie",
      "gem" + i,
      json.FQN,
      { definition: json.gemImages, x: position.x, y: position.y }
    );
    stripGemSprite.visible = false;
    stripGemSprite.gotoAndStop(0);
    reelBoxStrip.stripGemSprites.push(stripGemSprite);

    // Create win value text boxes
    if (json.fontDefinition) {
      var textBox = resourceManager.createObject(
        "text",
        "winValue",
        json.FQN + ":gem" + i,
        {
          anchor: json.anchor,
          fontDefinition: json.fontDefinition,
          x: json.textOffset.x,
          y: json.textOffset.y,
        }
      );
      if (typeof json.maxValueWidth != "undefined") {
        textBox.maxWidth = json.maxValueWidth;
      }
      textBox.visible = false;
      reelBoxStrip.stripTexts.push(textBox);
    }
  }

  reelBoxStripManager.reelBoxStrips.push(reelBoxStrip);
  resourceManager.get(json.reel).linkReelBoxStrip(reelBoxStrip, json.FQN);
};
reelBoxStripManager.destroyReelBoxStrip = function (reelBoxStrip) {
  var index = reelBoxStripManager.reelBoxStrips.indexOf(reelBoxStrip);
  if (index === -1) {
    console.log("Could not destroy reel box strip as it could not be found");
    return;
  }

  reelBoxStripManager.reelBoxStrips.splice(index, 1);
};

resourceManager.registerObjectType(
  "reelBoxStrip",
  reelBoxStripManager.createReelBoxStrip,
  reelBoxStripManager.initialiseReelBoxStrip,
  reelBoxStripManager.getFilesRequired,
  reelBoxStripManager.destroyReelBoxStrip
);
